module.exports = __webpack_public_path__ + "img/GS_corpuls.bbfca435.png";